import { render, staticRenderFns } from "./HomeMyRecordsComponent.vue?vue&type=template&id=b49f6ad6&scoped=true&"
import script from "./HomeMyRecordsComponent.vue?vue&type=script&lang=js&"
export * from "./HomeMyRecordsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49f6ad6",
  null
  
)

export default component.exports